exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".namepage{height:100%;width:100%;background:#fff;padding:0 .12rem;-webkit-box-sizing:border-box;box-sizing:border-box}.nametitle{height:.8rem;line-height:.8rem;text-align:center;font-size:.3rem;font-family:MicrosoftYaHei;font-weight:400;color:#333;border-bottom:.01rem solid #ddd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4153e64a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/section-office/office-name.vue
// module id = x+ee
// module chunks = 1